/**
 * albumCovers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const albumCoversPack: ToilePack = {
    slug: 'album-covers',
    category: 'album',
    name: 'Album covers',
    tagline: tagline('covers', 'records', 'styles'),
    chips: chips('records', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'lofi', label: 'Slow Hours', subject: 'a lofi bedroom at night, a cassette deck and a sleeping cat'},
        {key: 'synth', label: 'Chrome Coast', subject: 'a synthwave horizon, a chrome sun over an endless grid plain'},
        {key: 'folk', label: 'Elder Pine', subject: 'an indie-folk forest, mist between firs and a lantern on a stump'},
    ],
    styles: [
        {key: 'collage', label: 'Photo collage', style: 'photographic collage, cut-paper edges', palette: 'layered fragments, halftone texture', framing: 'square, reads at thumbnail size'},
        {key: 'drawn', label: 'Illustrated', style: 'fully illustrated, painted brushwork', palette: 'rich saturated color', framing: 'square, reads at thumbnail size'},
        {key: 'type', label: 'Typographic', style: 'typographic minimal, two flat shapes', palette: 'wide empty space, modernist sans', framing: 'square, reads at thumbnail size'},
    ],
    directions: ['a jazz record instead', 'in black and white', 'the title larger and bolder'],
}
